module.exports = __webpack_public_path__ + "img/3-1.4bf9248a.svg";